sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var Holidays = BlockBase.extend("com.reply.leaviosa.blocks.admin.Holidays", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.admin.Holidays",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.admin.Holidays",
					type: ViewType.XML
				}
			}
		}
	});

	return Holidays;
});